import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { StoreClosure } from '../../../models/store/StoreClosure';
import { StoreClosureResponse } from '../../../../interfaces/response/StoreResponses';

/**
 * An adapter converts store closure HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreClosureAdapter implements Adapter<StoreClosure[]> {

  /**
   * Converts store closure HTTP response to a list of {@link StoreClosure}.
   * @param item store closure HTTP response.
   */
  adapt(item: StoreClosureResponse[]): StoreClosure[] {
    if (!item) {
      return [];
    }

    const result: StoreClosure[] = [];
    item.forEach($item => result.push(new StoreClosure($item.date, $item.reason)));
    return result.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
